<template>
  <div>
    <!-- Use the new mainNavbar component -->
    <mainNavbar />
    <!-- Usar flexbox para el layout principal -->
    <div class="container-fluid overflow-hidden">
      <div class="row vh-100 flex-nowrap">
        <!-- Sidebar envuelto en un div para control CSS -->
          <AppSidebar class="sidebar-container" />

        <!-- Contenido principal ocupa el resto y permite scroll vertical -->
        <main class="col d-flex flex-column h-100 overflow-auto">
          <Navbar class="adMArings" />
          <!-- Asegurar que router-view crezca para llenar el espacio -->
          <div class="flex-grow-1">
            <router-view></router-view>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>
<script>
  import Navbar from '@/components/Navbar.vue';
  // Import the new mainNavbar component
  import mainNavbar from '@/components/mainNavbar.vue';
  // Cambiar alias de importación para claridad
  import AppSidebar from '@/components/Footer.vue';
   var config = require("@/config/api.json");

  import { auth } from "@/fb";

  export default {
    name: 'Dashaboard',
    components: {
      Navbar, AppSidebar, mainNavbar // Register the new component
    },
    watch: {

    },
    data() {
      return {
        storedUser: null,
      };
    },
    async created() {
      try {
        localStorage.removeItem('user');
        await this.checkAuthState();
        const user = auth.currentUser;
        // console.log('CREA DASHBOARD:::::::::::::------------------::::::::::::::')
        if (user) {
          this.storedUser = JSON.parse(localStorage.getItem('user'));
          // console.log('USUARIO GUARDADO---------------***----------------', this.storedUser)
          // console.log('RUTA:::',this.$route.path)
        }
      } catch (error) {
        console.error("Error en mounted: ", error);
        // Manejar el error, por ejemplo, redirigir al usuario, mostrar un mensaje, etc.
      }


    },
    // mounted() {
    //   // console.log('RUTA:::',this.$route.path)
    //   if (this.$route.path !== '/home') {
    //     setTimeout(() => {
    //       // console.log('redireccion')
    //       this.$router.push({ name: 'Home' });
    //     }, 3000);
    //   }

    // },
    methods: {
    },
  }
</script>

<style scoped>
/* Optional: Hide the main Navbar component on small screens if needed */
/* @media (max-width: 575.98px) {
  main > Navbar {
    display: none;
  }
} */

/* Ocultar el sidebar en pantallas pequeñas */
@media (max-width: 575.98px) {
  .sidebar-container {
    display: none;
  }
  .adMArings {
    margin-top: 5rem; /* Adjusted margin for Navbar on small screens */
  }
}
</style>